module.exports = __webpack_public_path__ + "static/media/builtinv2-Иконка пол.0b95275c.svg";